<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Add Dependent</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-3">
          <txt label="Dependent Name" name="dependent_name" v-model="model.dependent_name" />
        </div>
        <div class="col-3">
          <txt label="Relation" name="relation" v-model="model.relation" />
        </div>
        <div class="col-3">
          <txt label="Age" name="age" v-model="model.age" />
        </div>
        <div class="col-3">
          <tl-select
            label="Marital Status"
            :options="['Unmarried', 'Married']"
            v-model="model.marital_status"
            @change="(val) => model.marital_status=val"
          ></tl-select>
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Dependent" type="secondary" @click="addMoreDependents()" />
        </div>
      </div>
      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="dependentList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key != 'srNo'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      toast: false,
      errmsg: "",
      model: {
        dependent_name: "",
        relation: "",
        age: "",
        marital_status: ""
      },
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Relation",
          key: "relation"
        },
        {
          label: "Age",
          key: "age"
        },
        {
          label: "Marital Status",
          key: "marital_status"
        }
      ],
      dependentList: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      dependentData: state => state.dependentData
    })
  },
  activated() {
    this.showSuccessMsg = false;
    this.setDependentData();
  },
  methods: {
    ...mapActions({
      saveData:
        "dashboard/organisation/utilities/itdeclarations/saveDependentData"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        await this.saveData({
          id: this.$route.query.id,
          data: this.dependentList
        });
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreDependents() {
      try {
        this.dependentList.push({
          name: this.model.dependent_name,
          relation: this.model.relation,
          age: this.model.age,
          marital_status: this.model.marital_status
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          dependent_name: "",
          relation: "",
          age: "",
          marital_status: ""
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setDependentData() {
      try {
        if (this.dependentData[this.$route.query.id]) {
          this.dependentList = this.dependentData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.dependentList.findIndex(
          item => item.name == record.name
        );
        this.dependentList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
</style>
